// extracted by mini-css-extract-plugin
module.exports = {"container":"fd","image":"fe","title":"ff","desc":"fg"};